import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { DocumentationApi } from '@app/data-access/documentation/documentation.api';
import { IDocumentationComment } from '@data/schema';

/** Komentarze plików i folderów dokumentacji — rozpakowuje odpowiedzi `DocumentationApi`. */
@Injectable({ providedIn: 'root' })
export class CommentsBoxService {
  private readonly api = inject(DocumentationApi);

  getComments(
    id: number,
    isFolder: boolean,
    search?: string,
    senderId?: number,
    dateFrom?: Date,
    dateTo?: Date,
    entityId?: number
  ): Observable<IDocumentationComment[]> {
    return this.api
      .searchComments({ id, isFolder, search, senderId, dateFrom, dateTo, entityId })
      .pipe(map((rs) => rs.comments));
  }

  setComment(isFolder: boolean, fileFolderId: number, content: string): Observable<IDocumentationComment> {
    return this.api.addComment({ isFolder, fileFolderId, content, resolved: false }).pipe(map((rs) => rs.comment));
  }

  editComment(id: number, content: string): Observable<IDocumentationComment> {
    return this.api.editComment(id, content).pipe(map((rs) => rs?.comment));
  }

  removeComment(id: number): Observable<void> {
    return this.api.removeComment(id);
  }

  setCommentResolve(commentId: number, resolved: boolean): Observable<void> {
    return this.api.setCommentResolved(commentId, resolved);
  }
}
